import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    model: {}
};
var slice = createSlice({
    name: 'appBridge',
    initialState: initialState,
    reducers: {
        connectAppBridge: function (state, _a) {
            var payload = _a.payload;
            if (payload.hasOwnProperty("store")) {
                state.model = payload === null || payload === void 0 ? void 0 : payload.store;
            }
        }
    }
});
export var connectAppBridge = slice.actions.connectAppBridge;
export var storeConnector = { reducer: slice.reducer, reducerPath: "appBridge" };
